
const ComponentIcon = ({icon}) => {
  return (
    <div className='table-cell align-top pr2' style={{paddingTop: '4px'}}>{icon}</div>
  );
};

export default ComponentIcon;
